import loadAppManifest from './manifest-loader';
import loadAppAssets from './assets-loader';

export default (async function preLoad(name, locale) {
  const manifest = await loadAppManifest(name);
  return loadAppAssets(name, manifest, locale);
});
